/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isArray from 'lodash/isArray';
import shuffle from 'lodash/shuffle';

import ScheduleLinear from './schedule-linear';

/**
 * Náhodná strategie přehrávání.
 * Řízení přehrávání které přehráná média v náhodném pořadí.
 * Pořadí je náhodně vygenerováno při vytvoření a pak dodržováno.
 * @implements {ScheduleStrategy}
 */
class ScheduleRandom {
  /**
   * Vytvoří instanci.
   * @param {DS} store Datový sklad.
   * @param {Session} session Sezení s nastavením zařízení.
   * @param {Playlist} playlist Playlist pro aplikaci strategie.
   * @param {Array.<Track>} trackArray Seznam stop playlistu pro aplikaci strategie. Na pořadí nezáleží.
   * @param {ViewerRegistry} viewerRegistry Registr informací o typech médií.
   * @returns {ScheduleRandom} Nová instance.
   */
  constructor(store, session, playlist, trackArray, viewerRegistry) {
    if (!isArray(trackArray)) {
      throw new TypeError(`Invalid track array ${trackArray}.`);
    }
    this.scheduleLinear = new ScheduleLinear(
      store,
      session,
      playlist,
      shuffle(trackArray),
      viewerRegistry
    );
  }

  /** @inheritdoc */
  destroy() {
    this.scheduleLinear.destroy();
  }

  /** @inheritdoc */
  go() {
    return this.scheduleLinear.go();
  }

  /** @inheritdoc */
  off(...args) {
    this.scheduleLinear.off(...args);
  }

  /** @inheritdoc */
  on(...args) {
    this.scheduleLinear.on(...args);
  }

  /** @inheritdoc */
  plan(offset) {
    return this.scheduleLinear.plan(offset);
  }

  /** @inheritdoc */
  skip() {
    this.scheduleLinear.skip();
  }

  /** @inheritdoc */
  stop() {
    this.scheduleLinear.stop();
  }

  /** @inheritdoc */
  toString() {
    return `ScheduleRandom {playlist: ${this.playlist}}`;
  }
}

export default ScheduleRandom;
